var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonExportCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 486.4 486.4",
    style: {
      enableBackground: "new 0 0 486.4 486.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M434.7,474.8H52.1c-19.3,0-35-15.7-35-35V57.2c0-19.3,15.7-35,35-35h171.3c19.3,0,35,15.7,35,35 s-15.7,35-35,35H87.1v312.5h312.5V269.5c0-19.3,15.7-35,35-35s35,15.7,35,35v170.3C469.7,459.1,454,474.8,434.7,474.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M118.5,344.3v-29.4c0-22.4,16-37.2,40.1-37.2s40.1,14,40.1,35.1c0,0.9-0.9,1.5-2.6,1.6l-21.8,1.5 c-1.7,0.1-2.9-0.3-2.9-0.7v-0.9c0-7.9-5.1-13.1-12.8-13.1c-7.7,0-12.8,5.2-12.8,13.1v31.3c0,7.7,5.1,12.9,12.8,12.9 c7.7,0,12.8-5.2,12.8-12.9c0-1,1.2-1.7,2.9-1.6l21.8,1.2c1.7,0.1,2.6,0.3,2.6,0.7v0.7c0,21.2-16,35.3-40.1,35.3 S118.5,366.8,118.5,344.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M206.5,349.2v-1.5c0-1.7,1-2.8,2.8-2.8h21.4c1.7,0,2.8,0.6,2.8,1.5v1.6c0,4.9,5.8,10.3,14.8,10.3 c8.1,0,10-4.5,10-7.3c0-5.5-7.1-6.7-17.7-9.9c-13.5-4.1-33.9-11.8-33.9-32.7c0-18.8,16.3-30.8,38-30.8c22.8,0,40.4,13.5,40.4,33.7 v0.7c0,1.7-1,2.8-2.8,2.8h-21.4c-1.7,0-2.8-0.4-2.8-1.2v-1.2c0-5.2-5.1-11.5-14.5-11.5c-6.3,0-10,2.8-10,7.1 c0,5.2,5.4,7.4,20.5,12.2c10,3.2,31.6,8,31.6,30c0,19.1-16,31.4-39.4,31.4C222.3,381.8,206.5,369,206.5,349.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M317.2,378.3l-28.4-96.4c-0.6-2,0.4-3.1,2.3-3.1h23.7c1.6,0,2.6,0.7,3.1,2.5l14.1,59.6c0.3,1,1.2,1,1.5,0 l13.7-59.6c0.3-1.6,1.5-2.5,3.1-2.5h23.1c1.9,0,2.9,1,2.3,3.1L347,378.3c-0.4,1.5-1.6,2.3-3.2,2.3h-23.4 C318.8,380.6,317.6,379.8,317.2,378.3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M286,34.5c-2.9,7-1.2,15,4.1,20.3l48.4,48c10,9,21.3,21,56.3,55.8l43.5,43.1c5.3,5.3,13.4,6.8,20.3,4 c7-2.9,11.5-9.7,11.4-17.2l-0.6-147.4c0-10.3-8.5-18.7-18.7-18.6L303.3,23C295.7,22.9,288.9,27.6,286,34.5z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M280,238.9c-9,0-17.9-3.4-24.7-10.3c-13.7-13.7-13.7-35.8,0-49.5L344.3,90c13.7-13.7,35.8-13.7,49.5,0 c13.7,13.7,13.7,35.8,0,49.5l-89.1,89.1C297.9,235.4,289,238.9,280,238.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonExportCsv);
export default __webpack_public_path__ + "static/media/button-export-csv.4731091e0419bcef43313cab534bf531.svg";
export { ForwardRef as ReactComponent };